export function extendClassName(options: any, selector: string) {
  return function () {
    this.options.className = (selector.trim() + ` ${this.options.className}`).trim();

    return this;
  };
}
